import store from "@/store/index"
import Vue from "vue"
import VueRouter from "vue-router"

const AuthLayout = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ /* webpackChunkName: "login" */ "@/views/login/AuthLayout.vue")
const Login = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ /* webpackChunkName: "login" */ "@/views/login/Login.vue")
const ChangePassword = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ /* webpackChunkName: "login" */ "@/views/login/ChangePassword.vue")
const PageBase = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ /* webpackChunkName: "PageBase" */ "@/views/PageBase.vue")
const Dialog = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackChunkName: "dialog" */ "@/views/base/Dialog.vue")
const AppMain = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ /* webpackChunkName: "PageBase" */ "@/views/base/AppMain.vue")
const AppBarMobile = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ "@/views/base/header/AppBarMobile.vue")
const AppBarDesktop = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ "@/views/base/header/AppBarDesktop.vue")
const LeftMenu = () => import(/* webpackMode: "eager" */ /* webpackPrefetch: true */ "@/views/base/LeftMenu.vue")
const AppSnackBar = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/base/AppSnackBar.vue")
const AppLoading = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/base/AppLoading.vue")
const Zoom = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/base/Zoom.vue")
const Dashboard = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackChunkName: "Dashboard" */ "@/views/home/Dashboard.vue")

//forms
const PieceHistoryReport = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/reports/PieceHistoryReport.vue");
const OryxReportDetailedMovement = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/reports/OryxReportDetailedMovement.vue");

const LXD = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXD.vue");

const ET0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/ET0.vue");
const GridET0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridET0.vue");

const FI0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/FI0.vue");
const GridFI0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridFI0.vue");

const CO0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CO0.vue");
const GridCO0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCO0.vue");

const CR1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CR1.vue");
const GridCR1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCR1.vue");

const CVN = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CVN.vue");
const GridCVN = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCVN.vue");

const CV5RegOp = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CV5RegOp.vue");
const GridCV5RegOp = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV5RegOp.vue");

const PD0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD0.vue");
const GridPD0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD0.vue");

const PD1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD1.vue")
const GridPD1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD1.vue")

const EAN = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/EAN.vue");
const GridEAN = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridEAN.vue");

const PR0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PR0.vue");
const GridPR0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPR0.vue");

const GR0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/GR0.vue");
const GridGR0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridGR0.vue");

const PRS = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PRS.vue");
const GridPRS = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPRS.vue");

const PRB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PRB.vue");
const GridPRB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPRB.vue");

const PD2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD2.vue");
const GridPD2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD2.vue");

const PD3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD3.vue")
const GridPD3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD3.vue")

const GridVD1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVD1.vue")
const GridVD1Consig = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVD1Consig.vue")
const VD1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VD1.vue")

const GridCV8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV8.vue")

const PD4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD4.vue")
const OryxCartFooter = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cart/OryxCartFooter.vue")
const AppMainCart = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cart/AppMainCart.vue")
const OryxCartResume = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cart/OryxCartResume.vue")

const CF1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF1.vue")
const GridCF1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF1.vue")

const CF2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF2.vue")
const GridCF2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF2.vue")

const PD5 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD5.vue")
const GridPD5 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD5.vue")

const LXA = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXA.vue")

const LXE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXE.vue")

const LXH = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXH.vue")

const FNL = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/FNL.vue")
const GridFNL = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridFNL.vue")

const PD6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD6.vue")

const VDK = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VDK.vue")
const GridVDK = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVDK.vue")

const VDE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VDE.vue")
const NewVDE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/NewVDE.vue")
const GridVDE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVDE.vue")

const LoadingFinishSale = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cart/LoadingFinishSale.vue")

const OryxOpenCashier = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cashier/OryxOpenCashier.vue")
const OryxCloseCashier = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cashier/OryxCloseCashier.vue")
const OryxReportCashStatement = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cashier/OryxReportCashStatement.vue")
const GridCX0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCX0.vue")
const GridCX1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCX1.vue")
const CX1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CX1.vue")

const OryxCommissionClosing = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/representative/OryxCommissionClosing.vue")
const GridCO1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCO1.vue")
const CO1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CO1.vue")

const VE0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VE0.vue")
const GridVE0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVE0.vue")

const VEA = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VEA.vue")
const GridCommission = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCommission.vue")

const VE1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VE1.vue")
const GridVE1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVE1.vue")

const VE2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VE2.vue")
const GridVE2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVE2.vue")

const OryxReportItensByOrder = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/order/OryxReportItensByOrder.vue")

const OryxReportSalesByVendorRanking = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/vendor/OryxReportSalesByVendorRanking.vue")

const SendNfeMailDialog = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/mail/SendNfeMailDialog.vue")

const OryxReportOpenConsignments = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/consignment/OryxReportOpenConsignments.vue")

const OryxReportSalesByPeriod = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/sales/OryxReportSalesByPeriod.vue")

const OryxReportInvoicingByRepresentativeRanking = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/representative/OryxReportInvoicingByRepresentativeRanking.vue")

const OryxReportProductsSoldByPeriod = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/sales/OryxReportProductsSoldByPeriod.vue")

const CustomerHistory = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/customer/CustomerHistory.vue")

const OryxReportSalesRanking = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/sales/OryxReportSalesRanking.vue")

const OryxReportProductStock = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/stock/OryxReportProductStock.vue")

const OryxReportStockPointOfSale = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/stock/OryxReportStockPointOfSale.vue")

const OryxReportProductTurnover = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/reports/OryxReportProductTurnover.vue")

const PD8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/PD8.vue")
const GridPD8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridPD8.vue")

const IntegrationRepresentative = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/customer/IntegrationRepresentative.vue")

const UpdateStock = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/stock/UpdateStock.vue")
const ProductSearch = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/productSearch/ProductSearch.vue")

const DialogManager = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackChunkName: "dialog" */ "@/views/login/DialogManager.vue")

const WHA = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/WHA.vue")

const OryxReportProductSoldByVendor = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/sales/OryxReportProductSoldByVendor.vue")

const LXF = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXF.vue")
const GridLXF = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLXF.vue")

const MelhorEnvio = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/transporter/MelhorEnvio.vue")

const CFC = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFC")
const GridCFC = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFC")

const CFE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFE")
const GridCFE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFE")

const CFA = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFA")
const GridCFA = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFA")

const CVS = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CVS")
const GridCVS = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCVS")

const CF8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF8")
const GridCF8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF8")

const CF3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF3");
const GridCF3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF3");

const CF5 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF5")
const GridCF5 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF5")

const CF4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF4.vue");
const GridCF4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF4.vue");

const CF7 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF7.vue")
const GridCF7 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF7.vue")

const CFB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFB.vue")
const GridCFB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFB.vue")

const CF0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF0.vue")
const GridCF0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF0.vue")

const LXG = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXG.vue");
const GridLXG = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLXG.vue");

const ET3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/ET3.vue")
const GridET3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridET3.vue")

const CVX = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CVX.vue")
const GridCVX = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCVX.vue")

const VE3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VE3.vue")
const GridVE3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVE3.vue")

const VE4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VE4.vue");
const GridVE4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVE4.vue");

const EST = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/EST.vue");
const GridEST = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridEST.vue");

const CV1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CV1.vue");
const GridCV1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV1.vue");

const CFF = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFF.vue")
const GridCFF = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFF.vue")

const CFD = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFD.vue")
const GridCFD = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFD.vue")

const CF6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CF6.vue");
const GridCF6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCF6.vue");
const ME1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/ME1.vue");
const GridME1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridME1.vue");

const CV6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CV6.vue");
const GridCV6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV6.vue");

const CVM = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CVM.vue")
const GridCVM = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCVM.vue")

const CV2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CV2.vue");
const GridCV2 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV2.vue");

const DC4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/DC4.vue");
const GridDC4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridDC4.vue");


const DialogFiscalPaf = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/fiscal/DialogFiscalPaf.vue");

const CB0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CB0.vue");
const GridCB0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCB0.vue");

const CB1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CB1.vue");
const GridCB1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCB1.vue");

const OFH = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/OFH.vue");
const GridOFH = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOFH.vue");

const OFG = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/OFG.vue");
const GridOFG = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOFG.vue");

const VD4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VD4.vue");
const GridVD4 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVD4.vue");

const CV3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CV3.vue");
const GridCV3 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV3.vue");
const OryxReportCashFlowStatement = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/cashier/OryxReportCashFlowStatement.vue")

const ReferAndWin = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/referAndWin/ReferAndWin.vue")

const GridOF1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOF1.vue");
const OryxPlaceProductionOrder = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/ProductionOrder/OryxPlaceProductionOrder.vue");

const OryxPlaceCylinderReport = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/ProductionOrder/OryxPlaceCylinderReport");

const GridMED = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridMED.vue");
const MED = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/MED.vue");

const OryxPlaceReportLabels = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/ProductionOrder/OryxPlaceReportLabels.vue")

const GridME9 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridME9.vue");
const ME9 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/ME9.vue");

const ReportContainerLabels = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/ProductionOrder/ReportContainerLabels.vue")

const GridOFV = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOFV.vue");
const OFV = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/OFV.vue");

const GridOFW = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOFW.vue");
const OFW = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/OFW.vue");

const GridOFY = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridOFY.vue");
const OFY = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/OFY.vue");

const GridLX8 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLX8.vue")

const LXK = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXK.vue")

const GridCV5 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCV5.vue")

const GridMEB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridMEB.vue")
const MEB = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/MEB.vue")
const LeaseDocuments = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/financial/LeaseDocuments.vue")

const GridLOD = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLOD.vue")

const LXL = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXL.vue")

const GridCFH = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridCFH.vue")
const CFH = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/CFH.vue")

const GroupingDocuments = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/invoicing/GroupingDocuments.vue")
const GridDA1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridDA1.vue")
const OryxReportDistributionMap = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/reports/OryxReportDistributionMap.vue")


const GridIN0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridIN0.vue");
const IN0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/IN0.vue");

const GridLOE= () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLOE.vue");
const LOE = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LOE.vue");

const LXJ = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXJ.vue")

const GridFN9= () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridFN9.vue");
const FN9 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/FN9.vue");

const GridVD0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVD0.vue");
const VD0 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VD0.vue");

const GridVDQ = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridVDQ.vue")
const VDQ = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/VDQ.vue")

const AtualizationConfig = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/atualizationConfig/AtualizationConfigForm.vue");
const GridINC= () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridINC.vue");
const INC = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/INC.vue");

const GridFM1= () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridFM1.vue");
const FM1 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/FM1.vue");

const INF = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/INF.vue");

const NFEXmlOperations = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/financial/NFEXmlOperations.vue");
const MaterialReceivingForm = () => import( "@/views/materialReceiving/MaterialReceivingForm.vue");

const IN6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/IN6.vue");
const GridIN6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridIN6.vue");

const LXR = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LXR.vue")

const LX6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/files/LX6.vue");
const GridLX6 = () => import(/* webpackMode: "lazy" */ /* webpackPrefetch: true */ "@/views/grids/GridLX6.vue");

Vue.use(VueRouter)

const routes = [
	{
		path: "*",
		redirect: "/oryxpdv/caixa"
	},
	{
		path: "/",
		redirect: "/oryx/login"
	},
	{
		path: "/oryx",
		component: AuthLayout,
		children: [
			{
				path: "login",
				name: "login",
				component: Login
			},
			{
				path: "mudar-senha/:dc4usuario?/:dc4troca?",
				name: "changePassword",
				component: ChangePassword
			}
		]
	},
	{
		path: "/oryxpdv",
		component: PageBase,
		children: [
			{
				path: "",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						name: "oryxpdv",
						component: Dashboard
					}
				]
			},
			{
				path: "parametros",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxd", "est"], isLockedRoute: true },
						name: "lxd",
						component: LXD
					}
				]
			},
			{
				path: "estabelecimentos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["est"], isLockedRoute: true },
						name: "establishments",
						component: GridEST
					}
				]
			},
			{
				path: "estabelecimento/:estid?/:estcliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["est"], isLockedRoute: true, reduced: true },
						name: "establishment",
						component: EST
					}
				]
			},
			{
				path: "parametros-api",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxe"], isLockedRoute: true },
						name: "lxe",
						component: LXE
					}
				]
			},
			{
				path: "integracao-tef",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxh"], isLockedRoute: true },
						name: "lxh",
						component: LXH
					}
				]
			},
			{
				path: "parametros-rastreio",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxr"], isLockedRoute: true },
						name: "lxr",
						component: LXR
					}
				]
			},
			{
				path: "terminais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd0"], isLockedRoute: true },
						name: "terminals",
						component: GridPD0
					}
				]
			},
			{
				path: "terminal/:pd0codigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd0", "pda"], isLockedRoute: true, reduced: true },
						name: "terminal",
						component: PD0
					}
				]
			},
			{
				path: "preferencias-de-impressao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd1", "dc9", "pd0"], isLockedRoute: true },
						name: "printerPreferences",
						component: GridPD1
					}
				]
			},
			{
				path: "preferencia-de-impressao/:pd1codigo?/:pd1relat?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd1"], isLockedRoute: true, reduced: true },
						name: "printerPreference",
						component: PD1
					}
				]
			},
			{
				path: "parametros-financeiros",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxa", "lxq", "fn1", "fn3", "fn4", "cv2", "dr1"], reduced: true, isLockedRoute: true  },
						name: "lxa",
						component: LXA
					}
				]
			},
			{
				path: "produtos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pr0"] },
						name: "products",
						component: GridPR0
					}
				]
			},
			{
				path: "produto/:pr0produto?/:clone?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: [
							"pr0", "pr2", "pr3", "gr0", "gr1", "pre",
							"cvf", "cvg", "cv6", "gr3", "prc", "cr1",
							"fi0", "co0", "et0", "prb", "prs", "prg"
							], reduced: true },
						name: "product",
						component: PR0
					}
				]
			},
			{
				path: "grades-de-tamanho/",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["gr0", "gr1"] },
						name: "sizeGrids",
						component: GridGR0
					},
				]
			},
			{
				path: "grade-de-tamanho/:gr0grade?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["gr0", "gr1"], reduced: true },
						name: "sizeGrid",
						component: GR0
					}
				]
			},
			{
				path: "produto-grupos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["prs"] },
						name: "productGroups",
						component: GridPRS
					}
				]
			},
			{
				path: "produto-grupo/:prsgrupo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["prs"], reduced: true },
						name: "productGroup",
						component: PRS
					}
				]
			},
			{
				path: "produto-familias",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["prb"] },
						name: "productFamilies",
						component: GridPRB
					}
				]
			},
			{
				path: "produto-familia/:prbfamilia?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["prb"], reduced: true },
						name: "productFamily",
						component: PRB
					}
				]
			},
			{
				path: "produto-codigos-ean",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ean", "pr0", "cr1", "gr1"] },
						name: "EanCodifications",
						component: GridEAN
					}
				]
			},
			{
				path: "produto-codigo-ean/:eancodigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ean"], reduced: true },
						name: "EanCodification",
						component: EAN
					}
				]
			},
			{
				path: "parametros-operacoes-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd2", "cv1", "cv3"], isLockedRoute: true },
						name: "salesOperationParameters",
						component: GridPD2
					}
				]
			},
			{
				path: "parametro-operacoes-venda/:pd2codigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd2"], isLockedRoute: true, reduced: true },
						name: "salesOperationParameter",
						component: PD2
					}
				]
			},
			{
				path: "parametros-shopping",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd5"], isLockedRoute: true },
						name: "mallParameters",
						component: GridPD5
					}
				]
			},
			{
				path: "parametro-shopping/:pd5codigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd5"], isLockedRoute: true, reduced: true },
						name: "mallParameter",
						component: PD5
					}
				]
			},
			{
				path: "parametros-cheque",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd6", "pd7"] },
						name: "pd6",
						component: PD6
					}
				]
			},
			{
				path: "condicoes-pagamento",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd4", "cv2"] },
						name: "PaymentConditions",
						component:  GridVD4
					}
				]
			},
			{
				path: "condicao-pagamento/:vd4conpgto?/:clone?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd4", "vd9", "cv2"], reduced: true },
						name: "PaymentCondition",
						component: VD4
					}
				]
			},
			{
				path: "documentos-fiscais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv1"] },
						name: "FiscalDocuments",
						component: GridCV1
					}
				]
			},
			{
				path: "documento-fiscal/:cv1docfis?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv1"], reduced: true },
						name: "FiscalDocument",
						component: CV1
					}
				]
			},
			{
				path: "tipos-titulo",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv2"] },
						name: "titleTypes",
						component: GridCV2
					}
				]
			},
			{
				path: "tipo-titulo/:cv2titulo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv2"], reduced: true },
						name: "titleType",
						component: CV2
					}
				]
			},
			{
				path: "parametros-principais-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd3"], isLockedRoute: true },
						name: "pd3",
						component: PD3
					}
				]
			},
			{
				path: "caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["PD3", "VD1", "VDK", "CF1", "CV2", "CV5", "CV7", "CF3", "CV8"] },
						name: "cashier",
						component: GridPD3
					}
				]
			},
			{
				path: "venda/:vd1pedido?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMainCart,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
					OryxCartFooter,
					OryxCartResume
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["PD4", "VD1", "CFE", "CFF", "CVS", "CFD", "CF0", "CFB", "CFC", "CF1", "VD8", "VDV", "PR0", "VD2", "VD3", "VD5", "CV5", "OF3", "EAN", "FNL", "CFG", "CV8", "CV2", "PR2", "PR3", "VDK", "VDL", "VDX", "CFA"] },
						name: "sale",
						component: PD4
					}
				]
			},
			{
				path: "pedido/:vd1pedido",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
					SendNfeMailDialog
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VD1", "CF1", "CV6", "VD8", "VDV", "PR0", "VD2", "VD3", "VD5", "OF3", "EAN", "CV5", "CV8"] },
						name: "order",
						component: VD1
					}
				]
			},
			{
				path: "pedidos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd1", "vd2", "vd3", "cf1"] },
						name: "orders",
						component: GridVD1
					}
				]
			},
			{
				path: "pedidos-consignados",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: {
							dc0arquivo: ["vd1", "vd2", "vd3", "cf1"],
							title: "Consignados em aberto"
						},
						name: "consignedOrders",
						component: GridVD1Consig
					}
				]
			},
			{
				path: "movimentacao-de-titulos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: {
							dc0arquivo: ["cv8", "cv5", "fn6", "fn5", "fn4", "cf1", "fn3", "fn1", "vd1", "cv1", "cv5", "cv2", "dr1","fn9","fn8", "fnl"],
							title: "Movimentação de títulos"
						},
						name: "cv8Titles",
						component: GridCV8
					}
				]
			},
			{
				path: "clientes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1"] },
						name: "customers",
						component: GridCF1
					}
				]
			},
			{
				path: "cliente/:cf1cliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "cf2", "cf3", "cfe", "cff", "cvs", "cfd", "cfa", "cf0", "cfb", "cfc", "cfg", "fnl", "vd1", "cv5", "cv7", "cv8", "pr0", "in0", "loe", "ve0"], ignoreModules: ["vd1", "cv5", "cv7", "cv8", "pr0", "in0", "loe", "ve0"]},
						name: "customer",
						component: CF1
					}
				]
			},
			{
				path: "eventos/:cf1cliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfd", "cf1"] },
						name: "events",
						component: GridCFD
					}
				]
			},
			{
				path: "evento/:cfdevento?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfd", "cf1", "dc4"], reduced: true },
						name: "event",
						component: CFD
					}
				]
			},
			{
				path: "representantes/",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf6", "cf1"] },
						name: "representatives",
						component: GridCF6
					},
				]
			},
			{
				path: "representante/:cf6repres?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf6", "cf9", "cf1", "cf4", "cv1", "cf8"], reduced: true },
						name: "representative",
						component: CF6
					},
				]
			},
			{
				path: "estados",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf4"] },
						name: "states",
						component: GridCF4
					}
				]
			},
			{
				path: "estado/:cf4estado?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf4"], reduced: true },
						name: "state",
						component: CF4
					}
				]
			},
			{
				path: "localidades",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf3", "cf4", "cf8"] },
						name: "locales",
						component: GridCF3
					}
				]
			},
			{
				path: "localidade/:cf3local?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf3", "cf4", "cf8"], reduced: true },
						name: "locale",
						component: CF3
					}
				]
			},
			{
				path: "tipos-de-cliente",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf5"] },
						name: "customer-types",
						component: GridCF5
					}
				]
			},
			{
				path: "tipo-de-cliente/:cf5tipo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf5"], reduced: true },
						name: "customer-type",
						component: CF5
					}
				]
			},
			{
				path: "codigos-cep",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf2", "cf1", "cf3"] },
						name: "zipcodes",
						component: GridCF2
					}
				]
			},
			{
				path: "codigo-cep/:cf2cep?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf2", "cf1", "cf3"], reduced: true },
						name: "zipcode",
						component: CF2
					}
				]
			},
			{
				path: "portadores-preferenciais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfc", "cf1", "fn1"] },
						name: "preferredBearers",
						component: GridCFC
					}
				]
			},
			{
				path: "portador-preferencial/:cfccliente?/:cfcagente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfc", "cf1", "fn1"], reduced: true },
						name: "preferredBearer",
						component: CFC
					}
				]
			},
			{
				path: "contatos/:cfecliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfe", "cf1"] },
						name: "contacts",
						component: GridCFE
					}
				]
			},
			{
				path: "contato/:cfecliente?/:cfenome?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfe", "cf1"], reduced: true },
						name: "contact",
						component: CFE
					}
				]
			},
			{
				path: "dados-pessoais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfa", "cf1"] },
						name: "personalData",
						component: GridCFA
					}
				]
			},
			{
				path: "dado-pessoal/:cfacliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfa", "cf1"], reduced: true },
						name: "personalDatum",
						component: CFA
					}
				]
			},
			{
				path: "bloqueios",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvs", "cf1", "dc4", "cfb"] },
						name: "blocks",
						component: GridCVS
					}
				]
			},
			{
				path: "bloqueio/:cvscliente?/:cvsbloq?/:cvsenderid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvs", "cf1", "dc4", "cfb"], reduced: true },
						name: "block",
						component: CVS
					}
				]
			},
			{
				path: "regioes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf8", "cf3", "cf4"] },
						name: "regions",
						component: GridCF8
					}
				]
			},
			{
				path: "regiao/:cf8regiao?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf8", "cf3", "cf4"], reduced: true },
						name: "region",
						component: CF8
					}
				]
			},
			{
				path: "creditos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fnl", "cf1"] },
						name: "credits",
						component: GridFNL
					}
				]
			},
			{
				path: "credito/:fnlemissor?/:fnltipo?/:fnldoc?/:fnlcliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fnl", "CV5"] },
						name: "credit",
						component: FNL
					}
				]
			},
			{
				path: "devolucao/:vdkdoc?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VDK", "VDL", "VDX", "OF3", "EAN", "VD3", "VD5", "CV5", "PR0", "PR2", "PR3","CV6"] },
						name: "return",
						component: VDK
					}
				]
			},
			{
				path: "devolucoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VDK", "VDL", "VDX", "OF3", "EAN", "CF1"] },
						name: "returns",
						component: GridVDK
					}
				]
			},
			{
				path: "novo-confirmacao-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VDE", "VDF", "VDZ", "OF3", "EAN", "PR0", "PR2", "PR3", "VD6"] },
						name: "newSaleConfirmation",
						component: NewVDE
					}
				]
			},
			{
				path: "confirmacao-venda/:vdedoc",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VDE", "VDF", "VDZ", "OF3", "EAN", "PR0", "PR2", "PR3"], reduced: true },
						name: "saleConfirmation",
						component: VDE
					}
				]
			},
			{
				path: "confirmacoes-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["VDE", "VDF", "VDZ", "OF3", "EAN", "CF1"] },
						name: "salesConfirmation",
						component: GridVDE
					}
				]
			},
			{
				path: "venda-concluida",
				components: { LoadingFinishSale }
			},
			{
				path: "abrir-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX0", "VD1", "CV8", "CV2", "CX1"], title: "Abertura de caixa" },
						name: "openCashier",
						component: OryxOpenCashier
					}
				]
			},
			{
				path: "fechar-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX0", "VD1", "CV8", "CV2"], title: "Fechamento de caixa" },
						name: "closeCashier",
						component: OryxCloseCashier
					}
				]
			},
			{
				path: "caixas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX0", "CX1"] },
						name: "cashiers",
						component: GridCX0
					}
				]
			},
			{
				path: "demonstrativo-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX0", "PD0", "CV8", "VD1", "CV2"], title: "Demonstrativo de caixa" },
						name: "cashStatement",
						component: OryxReportCashStatement
					}
				]
			},
			{
				path: "demonstrativo-movimentacao-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX0", "CX1", "PD0", "CV8", "VD1", "CV2"], title: "Movimentações de caixa" },
						name: "cashFlowStatement",
						component: OryxReportCashFlowStatement
					}
				]
			},
			{
				path: "relacao-itens-pedido",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd1"], title: "Relação de itens por pedido" },
						name: "itensByOrder",
						component: OryxReportItensByOrder
					}
				]
			},
			{
				path: "movimentos-caixa",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX1", "CX0"] },
						name: "cashFlows",
						component: GridCX1
					}
				]
			},
			{
				path: "movimentacao-caixa/:cx1registr?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CX1"], isLockedRoute: true, redirectRoute: "/oryxpdv/movimentos-caixa", useFullAuthentication: true },
						name: "cashFlow",
						component: CX1
					}
				]
			},
			{
				path: "fechamento-comissao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CO1", "CO2", "CV5"] },
						name: "commisssionClosing",
						component: OryxCommissionClosing
					}
				]
			},
			{
				path: "comissao-acertada/:co1fecha",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CO1", "CO2", "CV5"] },
						name: "agreedCommisssion",
						component: CO1
					}
				]
			},
			{
				path: "fechamentos-comissao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["CO1", "cf6"], title: "Comissões pagas" },
						name: "commisssionsClosing",
						component: GridCO1
					}
				]
			},
			{
				path: "vendedores",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve0", "cf1"] },
						name: "vendors",
						component: GridVE0
					}
				]
			},
			{
				path: "vendedor/:ve0vend?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve0", "inc"], ignoreModules: ["inc"], reduced: true },
						name: "vendor",
						component: VE0
					}
				]
			},
			{
				path: "tipos-de-metas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve1"] },
						name: "goalTypes",
						component: GridVE1
					}
				]
			},
			{
				path: "tipo-de-meta/:ve1tipo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve1"], reduced: true },
						name: "goalType",
						component: VE1
					}
				]
			},
			{
				path: "metas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve2", "ve1"] },
						name: "goals",
						component: GridVE2
					}
				]
			},
			{
				path: "meta/:ve2meta?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve2"], reduced: true },
						name: "goal",
						component: VE2
					}
				]
			},
			{
				path: "faturamento-vendedor-ranking",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve0"], title: "Vendas por vendedor" },
						name: "salesByVendorRanking",
						component: OryxReportSalesByVendorRanking
					}
				]
			},
			{
				path: "consignados-abertos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd1"], title: "Consignados em aberto" },
						name: "reportOpenConsignments",
						component: OryxReportOpenConsignments
					}
				]
			},
			{
				path: "vendas-por-periodo",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "cv8"], title: "Vendas por período" },
						name: "reportSalesByPeriod",
						component: OryxReportSalesByPeriod
					}
				]
			},
			{
				path: "faturamento-guia-ranking",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5"], title: "Faturamento por Guia - Ranking" },
						name: "reportInvoicingByRepresentativeRanking",
						component: OryxReportInvoicingByRepresentativeRanking
					}
				]
			},
			{
				path: "produtos-vendidos-por-periodo",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "cv7", "pr0", "cf3"], title: "Produtos vendidos por período" },
						name: "reportProductsSoldByPeriod",
						component: OryxReportProductsSoldByPeriod
					}
				]
			},
			{
				path: "ranking-vendas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5"], title: "Ranking de vendas" },
						name: "reportSalesRanking",
						component: OryxReportSalesRanking
					}
				]
			},
			{
				path: "cliente-resumo/:cf1cliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "vd1", "cv5", "cv7", "cv8", "pr0", "cf3"], title: "Resumo do cliente" },
						name: "customerHistory",
						component: CustomerHistory
					}
				]
			},
			{
				path: "estoque-produtos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["of3", "pr0", "of1", "cv6", "vd1", "mvb"], title: "Estoque de Produtos" },
						name: "reportProductStock",
						component: OryxReportProductStock
					}
				]
			},
			{
				path: "estoque-ponto-de-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ean", "pr0", "cv7", "cv8", "cv5"], title: "Estoque Ponto de Venda" },
						name: "reportStockPointOfSale",
						component: OryxReportStockPointOfSale
					}
				]
			},
			{
				path: "movimentacao-produtos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "pr0", "cv7"], title: "Movimentação de produtos" },
						name: "reportProductTurnover",
						component: OryxReportProductTurnover
					}
				]
			},
			{
				path: "parametros-integracao-guia",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd8"], isLockedRoute: true },
						name: "integrationRepresentativeParameters",
						component: GridPD8
					}
				]
			},
			{
				path: "parametro-integracao-guia/:pd8codigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["pd8"], reduced: true },
						name: "integrationRepresentativeParameter",
						component: PD8
					}
				]
			},
			{
				path: "integracao-guias",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "cf6"], title: "Integração Guias" },
						name: "integrationRepresentative",
						component: IntegrationRepresentative
					}
				]
			},
			{
				path: "atualizar-dados",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["of3"], title: "Atualizar dados" },
						name: "updateStock",
						component: UpdateStock
					}
				]
			},
			{
				path: "parametros-oryx-whatsapp",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["wha"], isLockedRoute: true },
						name: "wha",
						component: WHA
					}
				]
			},
			{
				path: "produtos-vendidos-por-vendedor",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "cv7", "ve0"], title: "Produtos vendidos por vendedor" },
						name: "reportProductSoldByVendor",
						component: OryxReportProductSoldByVendor
					}
				]
			},
			{
				path: "integracoes-logisticas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxf"], isLockedRoute: true },
						name: "logisticsIntegration",
						component: GridLXF
					}
				]
			},
			{
				path: "integracao-logistica/:lxfcodigo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxf"], reduced: true },
						name: "logisticIntegration",
						component: LXF
					}
				]
			},
			{
				path: "melhorenvio",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						name: "melhorEnvio",
						component: MelhorEnvio
					}
				]
			},
			{
				path: "transportadores",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf7", "cf1"] },
						name: "carriers",
						component: GridCF7
					}
				]
			},
			{
				path: "transportadora/:cf7transp?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf7", "cf1"], reduced: true },
						name: "transporter",
						component: CF7
					}
				]
			},
			{
				path: "enderecos-de-entrega",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfb", "cf1", "cf3", "vd1", "cf2"] },
						name: "shippingAddresses",
						component: GridCFB
					}
				]
			},
			{
				path: "endereco-entrega/:cfbcliente?/:cfbid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfb", "cf1", "cf3", "vd1", "cv2", "cfh", "cf2"], reduced: true },
						name: "shippingAddress",
						component: CFB
					}
				]
			},
			{
				path: "enderecos-cobranca",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf0", "cf1", "cf3"] },
						name: "billingAddresses",
						component: GridCF0
					}
				]
			},
			{
				path: "endereco-cobranca/:cf0cliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf0", "cf1", "cf3"], reduced: true },
						name: "billingAddress",
						component: CF0
					}
				]
			},
			{
				path: "agencias-de-postagem",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxg", "cf7"] },
						name: "postageAgencies",
						component: GridLXG
					}
				]
			},
			{
				path: "agencia-de-postagem/:lxgtransp?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxg"], reduced: true },
						name: "postageAgency",
						component: LXG
					}
				]
			},
			{
				path: "inscricoes/:cffcliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cff", "cf1"] },
						name: "registrations",
						component: GridCFF
					}
				]
			},
			{
				path: "inscricao/:cffcliente?/:cffinsest?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cff"], reduced: true },
						name: "registration",
						component: CFF
					}
				]
			},
			{
				path: "etiquetas-de-postagem",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["et3", "vd1", "cf1"] },
						name: "postageTags",
						component: GridET3
					}
				]
			},
			{
				path: "etiqueta-de-postagem/:et3etiquet?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["et3"] },
						name: "postageTag",
						component: ET3
					}
				]
			},
			{
				path: "precos-especiais-cliente",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvx", "cv6", "cf1"] },
						name: "specialPricesByCustomer",
						component: GridCVX
					}
				]
			},
			{
				path: "preco-especial-cliente/:cvxlista?/:cvxcliente?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvx", "cvz", "pr3", "pr0", "gr1"], reduced: true },
						name: "specialPriceByCustomer",
						component: CVX
					}
				]
			},
			{
				path: "precos-especiais-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in0", "cv6", "cf1", "cfb"]} ,
						name: "specialPricesBySale",
						component: GridIN0
					}
				]
			},
			{
				path: "preco-especial-venda/:in0lista?/:in0cliente?/:in0enderid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in0", "ina", "pr3", "in1", "gr1", "lxd", "cfb"], reduced: false },
						name: "specialPriceBySale",
						component: IN0
					}
				]
			},
			{
				path: "precos-especiais-locacao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["loe", "cv6", "cf1", "cfb"]} ,
						name: "specialPricesByLease",
						component: GridLOE
					}
				]
			},
			{
				path: "preco-especial-locacao/:loelista?/:loecliente?/:loeenderid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["loe", "ina", "pr3", "in1", "gr1", "lxd", "cfb", "lof"], reduced: false },
						name: "specialPriceByLease",
						component: LOE
					}
				]
			},
			{
				path: "previsoes-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve3", "pr0", "gr1", "cr1", "co0"] },
						name: "salesForecastItems",
						component: GridVE3
					}
				]
			},
			{
				path: "previsao-venda/:ve3produto?/:ve3opcao?/:ve3tamanho?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve3", "pr0", "gr1", "cr1"], reduced: true },
						name: "saleForecastItem",
						component: VE3
					}
				]
			},
			{
				path: "tipos-de-venda",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve4"] },
						name: "salesTypes",
						component: GridVE4
					}
				]
			},
			{
				path: "tipo-de-venda/:ve4tipo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve4"], reduced: true },
						name: "saleType",
						component: VE4
					}
				]
			},
			{
				path: "usuarios",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["dc4"], reduced: true },
						name: "users",
						component: GridDC4
					}
				]
			},
			{
				path: "usuario/:dc4usuario?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: [ "dc4", "dc5", "dc0", "lgn", "est" ] },
						name: "user",
						component: DC4
					}
				]
			},
			{
				path: "movimentacoes-fisicas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["me1", "me0", "me6", "ax1"] },
						name: "physicalBalances",
						component: GridME1
					}
				]
			},
			{
				path: "movimentacao-fisica/:me1doc?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["me1", "me2", "in1"] },
						name: "physicalBalance",
						component: ME1
					}
				]
			},
			{
				path: "listas-de-preco",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv6"] },
						name: "priceLists",
						component: GridCV6
					}
				]
			},
			{
				path: "lista-de-preco/:cv6lista?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv6", "vd4"], reduced: true },
						name: "priceList",
						component: CV6
					}
				]
			},
			{
				path: "grupos-de-operacao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvm"] },
						name: "operationGroups",
						component: GridCVM
					}
				]
			},
			{
				path: "grupo-de-operacao/:cvmgrupo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvm"], reduced: true },
						name: "operationGroup",
						component: CVM
					}
				]
			},
			{
				path: "etiquetas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["et0"] },
						name: "tags",
						component: GridET0
					}
				]
			},
			{
				path: "etiqueta/:et0etiq?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["et0"], reduced: true },
						name: "tag",
						component: ET0
					}
				]
			},
			{
				path: "fabricantes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in6"] },
						name: "manufacturers",
						component: GridIN6
					}
				]
			},
			{
				path: "fabricante/:in6fabr?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in6"], reduced: true },
						name: "manufacturer",
						component: IN6
					}
				]
			},
			{
				path: "percentuais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lx6"] },
						name: "costProfiles",
						component: GridLX6
					}
				]
			},
			{
				path: "percentual/:lx6perfil?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lx6"], reduced: true },
						name: "costProfile",
						component: LX6
					}
				]
			},
			{
				path: "classificacoes-fiscais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fi0"] },
						name: "fiscalClassifications",
						component: GridFI0
					}
				]
			},
			{
				path: "classificacao-fiscal/:fi0id?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fi0"], reduced: true },
						name: "fiscalClassification",
						component: FI0
					}
				]
			},
			{
				path: "colecoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["co0"] },
						name: "collections",
						component: GridCO0
					}
				]
			},
			{
				path: "colecao/:co0colecao?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["co0"], reduced: true },
						name: "collection",
						component: CO0
					}
				]
			},
			{
				path: "cores",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cr1"] },
						name: "colors",
						component: GridCR1
					}
				]
			},
			{
				path: "cor/:cr1cor?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cr1"], reduced: true },
						name: "color",
						component: CR1
					}
				]
			},
			{
				path: "historico-da-peca",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: {
							dc0arquivo: ["cf1", "cf3", "ce0", "ce3", "cr1", "ofa", "ofh", "ofg", "of0", "of1", "of3", "of7", "pr0", "pr4", "ple", "me2", "mv3", "mv4", "vdl", "vd1", "vd8"],
							title: "Histórico de peças"
						},
						name: "pieceHistory",
						component: PieceHistoryReport
					}
				]
			},

			{
				path: "tributacoes-especificas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvn", "cv3", "in1", "pr0"] },
						name: "specificTaxes",
						component: GridCVN
					}
				]
			},
			{
				path: "tributacao-especifica",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cvn", "cv3", "dr1", "fi1", "fic", "fid"], reduced: true },
						name: "specificTax",
						component: CVN
					}
				]
			},
			{
				path: "pecas-nao-conformes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofh", "of3", "ofg"] },
						name: "NonConformingPieces",
						component: GridOFH
					}
				]
			},
			{
				path: "peca-nao-conforme/:ofhdoc?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofh", "of3", "ofg", "ce0", "pr0", "dc4"], reduced: true },
						name: "nonConformingPart",
						component: OFH
					}
				]
			},
			{
				path: "motivos-nao-conformidades",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofg"] },
						name: "ReasonsNonConforming",
						component: GridOFG
					}
				]
			},
			{
				path: "motivo-nao-conformidade/:ofgmotivo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofg"], reduced: true },
						name: "ReasonNonConforming",
						component: OFG
					}
				]
			},
			{
				path: "campanhas-cashbacks",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cb0"] },
						name: "CashbackCampaigns",
						component: GridCB0
					}
				]
			},
			{
				path: "campanha-cashback/:cb0camp?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cb0"], reduced: true },
						name: "CashbackCampaign",
						component: CB0
					}
				]
			},
			{
				path: "cupons-cashbacks",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cb1", "cf1"] },
						name: "CashbacksCoupons",
						component: GridCB1
					}
				]
			},
			{
				path: "cupom-cashback/:cb1cash?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cb1","vd1"], reduced: true },
						name: "CashbackCoupon",
						component: CB1
					}
				]
			},
			{
				path: '/oryxpdv/registro-de-operacoes/:cv5doc?/:cv5tipo?/:cv5emissor?',
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fn5", "fn1", "fn3", "fn4", "fn6", "fn7", "cv3", "cv5", "cv8", "cv1", "vd1", "cf6", "cv2", "cf1", "dr2"], title: 'Registro de operações'},
						name: "OperationRegister",
						component: CV5RegOp,
						props: true
					}
				]
			},
			{
			path: "tabela-registro-de-operacoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fn5", "fn1", "fn3", "fn6", "fn7", "cv3", "cv5", "cv8", "cv1", "vd1", "cf6", "cv2", "cf1", "dr2"], title: 'Registro de operações'},
						name: "OperationRegisterGrid",
						component: GridCV5RegOp,
						props: true
					}
				]
			},
			{
				path: "operacoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv3", "cv1"] },
						name: "operations",
						component: GridCV3
					}
				]
			},
			{
				path: "operacao/:cv3opercom?/:clone?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv3", "cvm", "dr1", "fi1", "cv1", "cv2", "vd4", "cv6", "cf1", "cf4", "cv4", "fic", "fid"], reduced: true },
						name: "operation",
						component: CV3
					}
				]
			},
			{
				path: "/indique-e-ganhe",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["dc1", "dc0"], reduced: false },
						name: "ReferAndWin",
						component: ReferAndWin
					}
				]
			},
			{
				path: "ordens-de-producao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["of1"] },
						name: "productionOrders",
						component: GridOF1
					}
				]
			},
			{
				path: "ordem-de-producao/:of1ordem?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["of1", "of2", "ofx", "med", "inc", "mea", "ofp","ofq", "ofr", "ofs", "oft", "ofu", "dc4", "pj0", "ofz", "lxk", "in1", "in6", "me9", "fm1", "en1"], ignoreModules: ["ofx", "med", "inc", "mea", "ofp","ofq", "ofr", "ofs", "oft", "ofu", "dc4", "pj0", "ofz", "lxk", "in1", "in6", "me9", "fm1", "en1"] },
						name: "productionOrder",
						component: OryxPlaceProductionOrder
					}
				]
			},
			{
				path: "distribuicoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["med", "inc"], ignoreModules: ["inc"]},
						name: "cylinderFillers",
						component: GridMED
					}
				]
			},
			{
				path: "distribuicao/:medcarga?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["med", "mea", "me9", "in1", "in6", "inc"], ignoreModules: ["me9", "in1", "in6", "inc"] },
						name: "cylinderFilling",
						component: MED,
						props: true
					}
				]
			},
			{
				path: "lote-etiquetas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["med", "pr0", "of1", "cv6", "vd1", "mvb"], ignoreModules: ["pr0", "of1", "cv6", "vd1", "mvb"], title: "Etiqueta de Lote" },
						name: "reportLabels",
						component: OryxPlaceReportLabels,
						props: true
					}
				]
			},
			{
				path: "cadastro-de-recipientes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["me9"] },
						name: "containerRegistrations",
						component: GridME9,
					}
				]
			},
			{
				path: "cadastro-de-recipiente/:me9idrecip?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["me9", "in1", "in6", "med", "mec"], ignoreModules: ["in1", "in6", "med", "mec"] },
						name: "containerRegistration",
						component: ME9
					}
				]
			},
			{
				path: "recipiente-etiquetas",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["med", "me9"], ignoreModules: ["med"], title: "Etiqueta de Recipientes" },
						name: "reportContainerLabels",
						component: ReportContainerLabels,
						props: true
					}
				]
			},
			{
				path: "parametros-insumo",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxk"], title: "Parâmetros de produção", isLockedRoute: true },
						name: "lxk",
						component: LXK,
					}
				]
			},
			{
				path: "registros-gerais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lx8"], title: "Registros gerais" },
						name: "generalRegisters",
						component: GridLX8,
						props: true
					}
				]
			},
			{
				path: "liquidacao-movimento-detalhado",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "fn5"], title: "Liquidação - Movimento Detalhado" },
						name: "reportDetailedMovement",
						component: OryxReportDetailedMovement
					}
				]
			},
			{
				path: "tanques-de-materia-prima",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofv"], reduced: true},
						name: "rawMaterialTanks",
						component: GridOFV
					}
				]
			},
			{
				path: "tanque-de-materia-prima/:ofvtanque?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofv"], reduced: true},
						name: "rawMaterialTank",
						component: OFV
					}
				]
			},
			{
				path: "parametros-de-materia-prima",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofw", "in1"], reduced: true },
						name: "rawMaterialParameters",
						component: GridOFW
					}
				]
			},
			{
				path: "parametro-de-materia-prima/:ofwcodins?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofw", "in1"], ignoreModules: ["in1"], reduced: true },
						name: "rawMaterialParameter",
						component: OFW
					}
				]
			},
			{
				path: "recepcao-de-materiais/:ofyid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofy", "ofv", "vd1", "cf1", "in1", "dc4", "inc"], ignoreModules: ["vd1", "cf1", "in1", "dc4", "inc"] },
						name: "materialReception",
						component: OFY
					}
				]
			},
			{
				path: "recepcoes-de-materiais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ofy", "ofv", "vd1", "cf1", "in1", "dc4"], ignoreModules: ["vd1", "cf1", "in1", "dc4"] },
						name: "materialReceptions",
						component: GridOFY
					}
				]
			},
			{
				path: "tabela-documentos-fiscais",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fn5", "fn1", "fn3", "fn6", "fn7", "cv3", "cv5", "cv8", "cv7", "cv1", "vd1", "cf6", "cv2", "cf1", "dr2", "ve0", "ve6"], title: "Documentos Fiscais" },
						name: "FiscalDocumentsGrid",
						component: GridCV5
					}
				]
			},
			{
				path: "locacao-de-cilindros",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "cv8", "cv3", "cf1", "cv7", "in1", "cf6", "vd1", "fn5", "fn3", "fn1", "cf5", "cfg"], title: "Locação de cilindros" },
						name: "LeaseDocuments",
						component: LeaseDocuments
					}
				]
			},
			{
				path: "documentos-de-locacao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cv5", "cv8", "cv3", "cf1", "cv7", "in1", "cf6", "vd1", "fn5", "fn3", "fn1", "lod", "loc"], title: "Documentos de locação" },
						name: "DocumentsFromLease",
						component: GridLOD
					}
				]
			},
			{
				path: "parametros-de-usuario",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxl"], isLockedRoute: true, reduced: true },
						name: "userParameters",
						component: LXL
					}
				]
			},
				{
				path: "agrupamentos-de-documentos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["DA1", "cfh", "cv3"], ignoreModules: ["cv3"], title: "Agrupamentos de Documentos" },
						name: "groupingsDocuments",
						component: GridDA1
					}
				]
			},
			{
				path: "agrupamento-documentos/:da1agrup?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
					path: "",
					meta: { dc0arquivo: ["DA1", "DA2", "DA3", "CV5", "CO1", "CO2", "CV1", "CV7", "CV3"] },
					name: "groupingDocuments",
					component: GroupingDocuments,
					},
				],
			},
			{
			path: "agrupamento-documentos/:cliente/:since/:until/:grpCfh/:cancelledAndReturned",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
					path: "",
					meta: { dc0arquivo: ["DA1", "DA2", "DA3", "CV5", "CO1", "CO2", "CV1", "CV7", "CV3"] },
					name: "generateGroupingDocuments",
					component: GroupingDocuments,
					},
				],
			},
			{
				path: "movimentacao-de-cilindros",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: {
							dc0arquivo: ["meb", "mee", "mec", "med", "cf1", "cf6", "cv1", "me9", "dc4", "cv3", "vd1"], ignoreModules: ["med", "cf1", "cf6", "cv1", "me9", "dc4", "cv3", "vd1"] ,
							title: "Movimentação de cilindros"
						}, //TODO: MUDAR
						name: "GridMEB",
						component: GridMEB
					}
				]
			},
			{
				path: "movimentacao-de-cilindros/visualizar",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["meb", "mee", "mec", "med", "cf1", "cf6", "cv1", "me9", "dc4", "cv3", "vd1"], ignoreModules: ["med", "cf1", "cf6", "cv1", "me9", "dc4", "cv3", "vd1"] },
						name: "cylinderMovement",
						component: MEB,
						props: route => ({
							mebdoclei: route.query.mebdoclei,
							mebtipo:    route.query.mebtipo,
							mebemissor: route.query.mebemissor,
							mebid:      route.query.mebid,
							mebsubseri: route.query.mebsubseri
						}),
					}
				]
			},
			{
				path: "mapa-de-distribuicao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["meb", "me9", "med", "in1"], ignoreModules: ["meb", "med", "in1"], title: "Mapa de Distribuição" },
						name: "reportDistributionMap",
						component: OryxReportDistributionMap
					}
				]
			},
			{
				path: "report-cylinder",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd1", "cf1", "cv3", "meb", "me9", "med", "cv1"], ignoreModules: ["vd1", "cf1", "cv3", "meb", "med", "cv1"], title: "Relatório de cilíndros" },
						name: "reportCylinder",
						component: OryxPlaceCylinderReport,
						props: route => ({
							mebdoclei: route.query.mebdoclei,
							mebtipo:    route.query.mebtipo,
							mebemissor: route.query.mebemissor,
							mebsubseri: route.query.mebsubseri,
							me9idrecip: route.query.me9idrecip,
							medcarga: route.query.medcarga,
						}),
					}
				]
			},
			{
				path: "grupos-de-endereco-de-entrega",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfh", "cf1", "cf3", "vd1"] },
						name: "shippingAddressGroups",
						component: GridCFH
					}
				]
			},
			{
				path: "grupo-de-endereco-de-entrega/:cfhcliente?/:cfhid?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cfh", "cf1", "cf3", "vd1", "cv2", "cfb", "cf2"], reduced: false },
						name: "shippingAddressGroupsRead",
						component: CFH
					}
				]
			},
			{
				path: "cheques",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fn9", "cf1", "cf3", "fn8", "cv2", "cfb", "fn8"] },
						name: "check",
						component: GridFN9
					}
				]
			},
			{
				path: "cheque/:fn9doc?/:fn9banco?/:fn9agencia?/:fn9compens?/:fn9cheque?/:fn9conta?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fn9", "cf1", "cf3", "fn8", "fnb", "cfb", "fn8"], reduced: false },
						name: "checks",
						component: FN9
					}
				]
			},
			{
				path: "parametros-oryxplace",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["lxj"], isLockedRoute: true },
						name: "lxj",
						component: LXJ
					}
				]
			},
			{
				path: "subclasses",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in1", "inc"], ignoreModules: ["in1"], title: "Sub Classes" },
						name: "inc",
						component: GridINC
					}
				]
			},
			{
				path: "subclasse/:incsubclas?/",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["in1", "inc"], ignoreModules: ["in1"], title: "Sub Classe", reduced: true  },
						name: "inc",
						component: INC
					}
				]
			},
				{
				path: "campos-analises",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fm1"], title: "Campos de Análise" },
						name: "fm1",
						component: GridFM1
					}
				]
			},
			{
				path: "campo-de-analise/:fm1id?/",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["fm1"], title: "Campo de Análise", reduced: true },
						name: "fm1",
						component: FM1
					}
				]
			},
			{
				path: "analises-sub-classes/:infsubclas?/",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["inf", "fm1", "inc"], ignoreModules: ["fm1", "inc"], title: "Analises de Sub Classes" },
						name: "inf",
						component: INF
					}
				]
			},
			{
				path: "NFEXml",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "cv5", "cv7", "cv8", "cv2", "vd4", "vd9", "in1", "cv8"], ignoreModules:["cv2", "vd4", "vd9"], title: "Entrada de NFE por XML"},
						name: "NFEXml",
						component: NFEXmlOperations
					}
				]
			},
			{
				path: "oryxplace-pedidos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "vdq", "vdp"], ignoreModules: ['cf1'], title: "Oryxplace Pedidos" },
						name: "oryxplaceOrders",
						component: GridVDQ
					}
				]
			},
			{
				path: "oryxplace-pedido/:vdqvisita?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "cv6", "cfb", "cv3", "cf6", "vdq", "cfg", "cfa", "ve0", "vd4", "vdw", "cv2", "in1", "in9", "vdp", "vd0"], ignoreModules: ['cf1', 'cv6', 'cfb', 'cv3', 'cf6', 'cfg', 'cfa', 've0', 'vd4', 'cv2', 'in1', 'in9'], title: "Oryxplace Pedidos"},
						name: "oryxplaceOrder",
						component: VDQ
					}
				]
			},
			{
				path: "cadastro-de-comissao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vea", "inc", "in1", "ve0", "cf1", "veb"], ignoreModules: ["inc", "in1", "ve0", "cf1", "veb"], reduced: true, title: "Cadastro de Comissões" },
						name: "commission",
						component: VEA
					}
				]
			},
			{
				path: "comissoes",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["ve0", "cf1", "vea"], ignoreModules: ["ve0", "cf1"], title: "Cadastro de Comissões" },
						name: "commissions",
						component: GridCommission
					}
				]
			},
			{
				path: "motivos",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd0"] },
						name: "reasonsRegistrationGrid",
						component: GridVD0
					}
				]
			},
			{
				path: "motivo/:vd0motivo?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["vd0"], reduced: true },
						name: "reasonsRegistrationForm",
						component: VD0
					}
				]
			},
			{
				path: "recebimento-material/:cv5doc?/:cv5tipo?/:cv5emissor?",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: { dc0arquivo: ["cf1", "cv5", "cv7", "cv3", "in1", "me9", "in6", "med", "mec"], ignoreModules: ["me9", "in6", "med", "mec"], title: "Recebimento de material para revenda"},
						name: "NfeReceiving",
						component: MaterialReceivingForm
					}
				]
			},
			{
				path: "configuracao-atualizacao",
				components: {
					AppBarMobile,
					AppBarDesktop,
					LeftMenu,
					AppMain,
					Dialog,
					DialogManager,
					AppSnackBar,
					AppLoading,
					ProductSearch,
					DialogFiscalPaf,
				},
				children: [
					{
						path: "",
						meta: {dc0arquivo: ["att"], isLockedRoute: true , reduced: true},
						name: "atualizationConfig",
						component: AtualizationConfig
					}
				]
			},
		]
	}
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

router.beforeEach(async (to, from, next) => {
	if (!to.meta.isLockedRoute) {
		next()
	} else if (!from.meta.isLockedRoute) {
		if (from.path === "/") {
			next({ path: to.meta.redirectRoute ?? "/caixa" });
		} else {
			await store.dispatch("parameters/openManagerDialog", {
				useSimpleAuthentication: !to.meta.useFullAuthentication,
				dc0arquivo: to.meta.dc0arquivo,
				permission: "DC5INCLUIR",
					confirmAction: () => {
						next()
					},
				},
				{ root: true },
			)
		}
	} else {
		next()
	}
})

router.afterEach(async to => {
	if (to.meta.dc0arquivo) {
		store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Carregando", indeterminate: true })
		await store.dispatch("parameters/getDc0", to.meta.dc0arquivo[0])
		await store.dispatch("form/getMultipleDc0", to.meta.dc0arquivo)
		await store.dispatch("form/getMultipleDc1", to.meta.dc0arquivo)
		store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" })
		var currentFilesPermissions = store.state.dc4.dc4.lstDc5.filter(dc5 => to.meta.dc0arquivo.map(dc0 => dc0.toUpperCase()).includes(dc5.dc5arquivo.toUpperCase()))
		if (to.meta.ignoreModules && to.meta.ignoreModules.length > 0)
			to.meta.ignoreModules.forEach(module =>
				!currentFilesPermissions.some(dc5 => dc5.dc5arquivo.toUpperCase() === module.toUpperCase()) &&
				currentFilesPermissions.push({ dc5arquivo: module })
			);
		var setCurrentFilesPermissions = currentFilesPermissions.length ? new Set(currentFilesPermissions) : new Set([])
		var setDc0ArquivoPermission = new Set(to.meta.dc0arquivo)
		if (!currentFilesPermissions.length || setCurrentFilesPermissions.size != setDc0ArquivoPermission.size) {
			store.dispatch(
				"parameters/openDialog",
				{
					titleText: "Erro",
					titleColor: "red",
					text: "Você não tem permissão para acessar este recurso",
					cancelAction: () => {
						router.push({ path: "/caixa" })
					},
				},
				{ root: true },
			)
		}
	} else {
		store.state.parameters.dc0 = null
	}

	if (to.name == "login") {
		store.dispatch("parameters/resetDialog")
	}
})

export default router
